seedWebApp.controller('IndexLogisticsCtrl', ['$scope', '$routeParams', '$location', '$window',
    function ($scope, $routeParams, $location, $window) {

        $scope.defaultPages = [
            { pageIndex: 0, pageLabel: 'Logistic Emails', pageDisplay: 'Logistics/Orders', pageUrl: 'SPA/logistics/logistics.html' + seedWebApp.buildVersion },
            { pageIndex: 1, pageLabel: 'Sent Emails', pageDisplay: 'Logistics/Orders', pageUrl: 'SPA/logistics/sentEmails.html' + seedWebApp.buildVersion },
        ];

        $scope.loadingTabs = true;
        $scope.selTab = $routeParams.Tab;

        $scope.tabSelected = function (page) {
            $location.search('Tab', page.pageIndex);
            $scope.selectedIndex = page.pageIndex;
        };

        //$scope.headerSize = 130;
        $scope.headerSize = 100;
        $(document).ready(function () {
            $scope.overflowSize = $scope.AdjustSize($scope.headerSize);
        });

        $window.onresize = function () {
            $scope.overflowSize = $scope.AdjustSize($scope.headerSize);
        };

        $scope.$watch('modules', function () {
            if ($scope.modules) {
                $scope.verifyPermsAndDefineTabs($scope, 'Logistics');
            }
        });
    }
]);